// @ts-nocheck
import logger from '@/app/logger';
import * as actions from '../../action-types';
import * as mutations from '../../mutation-types';
import analyticsUtils from '@/utils/analytics-utils';
import isSSR from '@/utils/isSSR';
import { isStorybookUrlPath } from '@/utils/url';

export default {
  [actions.analytics.init]: ({ commit, dispatch }) => {
    commit(mutations.analytics.init);
    dispatch(actions.analytics.save);
  },
  [actions.analytics.set]: ({ commit, dispatch }, payload) => {
    if (!window.adobeAnalyticsData) {
      commit(mutations.analytics.init);
    }
    commit(mutations.analytics.init);
    commit(mutations.analytics.set, payload);
    dispatch(actions.analytics.save);
  },
  [actions.analytics.append]: ({ commit, dispatch }, payload) => {
    commit(mutations.analytics.set, payload);
    dispatch(actions.analytics.save);
  },
  [actions.analytics.ocmBannerReady]: ({ commit }, payload) => {
    commit(mutations.analytics.ocmBannerReady, payload);
  },
  [actions.analytics.track]: ({ state, getters }, event) => {
    if (getters.analyticsCallsSuspended) {
      logger.warn('Analytics calls have been suspended');
      return;
    }

    const waitForSatellite = (event: string, state: any, maxAttempts = 50, checkInterval = 100) => {
      let attempts = 0;

      const intervalId = setInterval(() => {
        if (
          typeof _satellite !== 'undefined' &&
          typeof _satellite.track === 'function' &&
          window.opConsent &&
          Object.keys(window.opConsent).length > 0
        ) {
          if (!isStorybookUrlPath(window.location.pathname)) {
            // Track analytics only if we are not in storybook to avoid: Error: [vuex] do not mutate vuex store state outside mutation handlers.
            logger.info('Satellite.track, event', { event });
            _satellite.track(event);
          } else {
            logger.info('Skipping analytics track sending. Event that would be sent:', {
              event,
              dataLayer: state.dataLayer,
            });
          }

          clearInterval(intervalId);
        } else if (attempts >= maxAttempts) {
          logger.warn(
            `Satellite library unreachable after ${maxAttempts} attempts, attempting to track the "${event}" event`
          );
          logger.warn('Current Data Layer', { dataLayer: state.dataLayer });
          clearInterval(intervalId);
        } else {
          attempts++;
        }
      }, checkInterval);
    };

    if (!isSSR) {
      waitForSatellite(event, state);
    }
  },
  [actions.analytics.save]: ({ state }) => {
    window.adobeAnalyticsData = state.dataLayer;
  },
  [actions.analytics.saveString]: ({ commit }, payload) => {
    commit(
      mutations.analytics.saveString,
      analyticsUtils.formAnalyticsInput(
        payload.filters,
        payload.cities,
        payload.districts,
        payload.streets,
        payload.regions
      )
    );
  },
  [actions.analytics.suspend]: ({ commit }, suspended) => {
    commit(mutations.analytics.suspend, suspended);
    return Promise.resolve();
  },
};
